export default __webpack_public_path__ + "alberta-eye.a20770c1c85d842c6619.svg";